/* Homepage shelf cards (sections home-shelf and home-bundles), 2026-10-22/23.
   Tabs, track arrows, same-height lines per pane, flavor swatches, + quick add via the theme's
   'theme:cart:add'. Bound once per page; both sections include this file. */
(function () {
  if (window.__hsBound) return;
  window.__hsBound = true;

  function arrows(pane) {
    var t = pane.querySelector('[data-hs-track]');
    var prev = pane.querySelector('[data-hs-prev]');
    var next = pane.querySelector('[data-hs-next]');
    if (!t || !prev || !next) return;
    var over = t.scrollWidth - t.clientWidth > 4;
    prev.hidden = !over || t.scrollLeft < 4;
    next.hidden = !over || t.scrollLeft > t.scrollWidth - t.clientWidth - 4;
  }
  // Same panel height on every card in a tab: match the subs to the tallest one.
  function equalize(pane) {
    var subs = pane.querySelectorAll('.hs-card__sub');
    var max = 0;
    subs.forEach(function (s) { s.style.minHeight = ''; max = Math.max(max, s.offsetHeight); });
    if (max) subs.forEach(function (s) { s.style.minHeight = max + 'px'; });
  }
  function initAll(scope) {
    scope.querySelectorAll('[data-hs-pane]').forEach(function (pane) {
      if (!pane.hidden) equalize(pane);
      var t = pane.querySelector('[data-hs-track]');
      if (t && !t.__hs) {
        t.__hs = true;
        t.addEventListener('scroll', function () { arrows(pane); }, { passive: true });
      }
      arrows(pane);
    });
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-hs-tab]');
    if (tab) {
      var root = tab.closest('[data-hs]');
      root.querySelectorAll('[data-hs-tab]').forEach(function (b) { b.setAttribute('aria-selected', b === tab ? 'true' : 'false'); });
      root.querySelectorAll('[data-hs-pane]').forEach(function (p) { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
      var pane = document.getElementById(tab.getAttribute('aria-controls'));
      if (pane) { var tr = pane.querySelector('[data-hs-track]'); if (tr) tr.scrollLeft = 0; equalize(pane); arrows(pane); }
      // keep the picked tab in view inside its own row (keeps the row's 16px edge; never moves the page)
      var row = tab.parentElement;
      var l = tab.offsetLeft - 16;
      var r = tab.offsetLeft + tab.offsetWidth - row.clientWidth + 40;
      if (row.scrollLeft > l) row.scrollTo({ left: Math.max(0, l), behavior: 'smooth' });
      else if (row.scrollLeft < r) row.scrollTo({ left: r, behavior: 'smooth' });
      return;
    }

    var arrow = e.target.closest('[data-hs-prev], [data-hs-next]');
    if (arrow) {
      var tr2 = arrow.closest('[data-hs-pane]').querySelector('[data-hs-track]');
      var card = tr2.querySelector('.hs-card');
      var step = card ? card.getBoundingClientRect().width + 16 : tr2.clientWidth * 0.8;
      tr2.scrollBy({ left: arrow.hasAttribute('data-hs-next') ? step : -step, behavior: 'smooth' });
      return;
    }

    var sw = e.target.closest('[data-hs-sw]');
    if (sw) {
      e.preventDefault();
      var f = sw.closest('[data-hs-card]');
      f.querySelectorAll('[data-hs-sw]').forEach(function (b) { b.setAttribute('aria-checked', b === sw ? 'true' : 'false'); });
      f.querySelector('input[name="id"]').value = sw.dataset.vid;
      f.querySelectorAll('[data-hs-link]').forEach(function (a) { a.href = sw.dataset.url; });
      var img = f.querySelector('[data-hs-img]');
      if (img) { img.srcset = sw.dataset.srcset; img.src = sw.dataset.img; }
      var fill = f.querySelector('[data-hs-fill]');
      if (fill) fill.src = sw.dataset.fill;
      var price = f.querySelector('[data-hs-price]');
      var ok = sw.dataset.available === 'true';
      if (price) price.textContent = ok ? sw.dataset.price : 'Sold out';
      var add = f.querySelector('[data-hs-add]');
      if (add) add.disabled = !ok;
      return;
    }

    var addBtn = e.target.closest('[data-hs-add]');
    if (addBtn) {
      e.preventDefault();
      if (addBtn.disabled) return;
      var form = addBtn.closest('[data-hs-card]');
      var vid = form.querySelector('input[name="id"]').value;
      try { window.Shopify && Shopify.analytics && Shopify.analytics.publish('home_shelf_quick_add', { handle: form.dataset.handle, variant_id: vid }); } catch (err) {}
      addBtn.classList.add('is-done');
      setTimeout(function () { addBtn.classList.remove('is-done'); }, 1600);
      if (document.querySelector('cart-drawer')) {
        document.dispatchEvent(new CustomEvent('theme:cart:add', { detail: { button: addBtn }, bubbles: false }));
        return;
      }
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
      }).catch(function () { window.location.href = form.querySelector('[data-hs-link]').href; });
    }
  });

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    initAll(document);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { initAll(document); });
  });
  window.addEventListener('resize', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
